"use client";

import { useState, useEffect } from "react";
import Icon from "@/components/ui/AppIcon";

interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

interface ProductCategoryFiltersProps {
  onFilterChange: (categoryId: string) => void;
  activeFilter: string;
}

export default function ProductCategoryFilters({
  onFilterChange,
  activeFilter,
}: ProductCategoryFiltersProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const categories: Category[] = [
    {
      id: "all",
      name: "All Products",
      icon: "Squares2X2Icon",
      count: 41,
    },
    {
      id: "precious",
      name: "Precious Metals",
      icon: "SparklesIcon",
      count: 8,
    },
    {
      id: "industrial",
      name: "Industrial",
      icon: "CogIcon",
      count: 12,
    },
    {
      id: "rare",
      name: "Rare Earth",
      icon: "BeakerIcon",
      count: 6,
    },
    {
      id: "gemstones",
      name: "Gemstones",
      icon: "GiftIcon",
      count: 15,
    },
  ];

  return (
    <div className="bg-card border border-border rounded-2xl p-6 mb-12">
      <div className="flex items-center gap-4 mb-6">
        <Icon name="FunnelIcon" size={20} className="text-primary" />
        <h3 className="text-sm font-semibold uppercase tracking-widest text-foreground font-mono">
          Filter by Category
        </h3>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => isHydrated && onFilterChange(category.id)}
            className={`p-4 rounded-xl border transition-all duration-300 text-left ${
              activeFilter === category.id
                ? "border-primary bg-primary/10 text-primary" :"border-border bg-background text-muted-foreground hover:border-primary/50 hover:bg-muted/50"
            }`}
          >
            <Icon
              name={category.icon as any}
              size={24}
              className={`mb-3 ${
                activeFilter === category.id
                  ? "text-primary" :"text-muted-foreground"
              }`}
            />
            <div className="text-sm font-semibold mb-1 font-heading">
              {category.name}
            </div>
            <div className="text-xs text-muted-foreground font-mono">
              {category.count} items
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}